import { ChangeDetectionStrategy, Component } from '@angular/core';
import { WishListItemComponent } from '@spartacus/cart/wish-list/components';
import { ProductListItemContext, ProductListItemContextSource } from '@spartacus/storefront';

@Component({
  selector: 'app-custom-wishlist-item',
  templateUrl: './custom-wishlist-item.component.html',
  styleUrls: ['./custom-wishlist-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    ProductListItemContextSource,
    {
      provide: ProductListItemContext,
      useExisting: ProductListItemContextSource,
    },
  ],
  standalone: false
})
export class CustomWishlistItemComponent extends WishListItemComponent {
}
